module.exports = __webpack_public_path__ + "img/four.523ee54d.jpg";